module.exports = __webpack_public_path__ + "static/media/bmi.a7d778f5.svg";